var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-link',{staticStyle:{"padding":"0px"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticStyle:{"padding-right":"15px"}},[_c('div',{attrs:{"id":"title"}},[_vm._v(_vm._s(_vm.title)),_vm._t("title")],2),_c('div',{attrs:{"id":"subtitle"}},[_vm._v(_vm._s(_vm.subtitle)),_vm._t("subtitle")],2)]),_vm._t("after")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }